import axios from "axios";

const wadoRoot = () => {
  return `${window.config.dataSources[0].configuration['wadoRoot']}/studies`;
}

export class PresentationStateService {

  GetPresentationState(STUDYUID_FKEY) {
    try {
      return axios.get(`${wadoRoot()}/${STUDYUID_FKEY}/PR/metadata`);
    } catch (error) {
      console.log(error);
    }
  }

}
